module.exports = __webpack_public_path__ + "img/0-sm.69e0161b.jpg";